import type { QueryClient } from '@tanstack/react-query';
import { SETTINGS_QUERY_KEYS, type AccountSettings } from '@/api/queries/settings';

export type LandingRoute = '/(tabs)/discover' | '/(tabs)/activity';

/**
 * Resolve the verified user's landing tab from the ALREADY-HYDRATED persisted
 * account-settings cache. This is a synchronous cache read — it never triggers a
 * fetch — so the first frame after auth can redirect without a flash. Falls back
 * to Discover for the no-cache / first-ever-boot case and for `defaultLandingScreen: 'discover'`.
 */
export function getLandingRoute(queryClient: QueryClient): LandingRoute {
  const account = queryClient.getQueryData<AccountSettings>(
    SETTINGS_QUERY_KEYS.account(),
  );
  return account?.defaultLandingScreen === 'activity'
    ? '/(tabs)/activity'
    : '/(tabs)/discover';
}
